import React from 'react';

const ButtonPlaceholder = () => {
  return (
    <div className="placeholder-row placeholder-st__bottom-signin animation" />
  );
};

export default ButtonPlaceholder;
